module.exports = __webpack_public_path__ + "static/media/6c58cc67.jpg";